import { Component } from '@angular/core';
import { ShareComponent } from '../share/share.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [ShareComponent],
})
export class FooterComponent {
  expandedSection: 'contribute' | 'company' | 'policies' | null = null;

  toggleSection(section: 'contribute' | 'company' | 'policies') {
    this.expandedSection = this.expandedSection === section ? null : section;
  }
}
